import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { SessionService } from '../auth/session-service';
import { TranslateService } from '@ngx-translate/core';
import { TranslationService } from '../services/translation-service';
import { RoleId } from '../../features/users/enums/role.enum';

export const roleGuard: CanActivateFn = (route) => {
  const translationService = inject(TranslationService);
  const translateService = inject(TranslateService);
  const sessionService = inject(SessionService);
  const router = inject(Router);

  const urlLang = translationService.currentLangOnStandard(translateService);

  const roles = route.data['roles'] as RoleId[];

  const hasAccess = roles?.length === 0 || sessionService.hasAnyRole(roles);

  if (!hasAccess) {
    return router.createUrlTree([`/${urlLang}/home`]);
  }

  return true;
};
